var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom__toolbar d-flex mb-5"},[_c('v-spacer'),_c('create')],1)}
var staticRenderFns = []

export { render, staticRenderFns }